module.exports = __webpack_public_path__ + "media/images/shop/logo-doctor-a20a412e62d2d5308a212c122f26b2ec.png";